<template>
  <div class="block__content">
    <Paragraph
      :size="data.textSize"
      :text="data.text"
      data-anim="text"
      data-view="false"
    />
  </div>
</template>

<script>
import Paragraph from '@/components/text/Paragraph.vue';

export default {
  name: 'BlockText',

  components: {
    Paragraph,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  &__content {
    margin-top: rem(100px);
  }
}
</style>
